<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>All RLD Zero Data</h1>
            </div>

            <div class="dropdown" style="margin: 10px 0px;">
                <p-dropdown autoWidth="false" [options]="sourceDropdownOptions" [(ngModel)]="selectedSource"
                    (onChange)="filterData()">
                </p-dropdown>
            </div>

            <div class="card">
                <p-table [value]="filteredData" [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>Innovator / RLD Price ($/pack)</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>
                                <button (click)="showSalesDialog(rowData)" icon="pi pi-external-link" label="Show">Show
                                    More</button>
                                <p-dialog *ngIf="rowData.new_price" header="Innovator / RLD Price ($/pack)"
                                    [(visible)]="rowData.new_price" [style]="{width: '50vw'}">
                                    <table border="1">
                                        <thead>
                                            <tr>
                                                <th>Strength</th>
                                                <th>Quantity</th>
                                                <th>Price per Unit</th>
                                                <th>Total Price</th>
                                                <th>Route of Administration</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of rowData['Innovator / RLD Price ($/pack)']['value']">
                                                <td>{{ item.Strengths }}</td>
                                                <td>{{ item.Quantity }}</td>
                                                <td>{{ item['Per unit'] }}</td>
                                                <td>{{ item.Price }}</td>
                                                <td>{{ item.Roa | titlecase }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </p-dialog>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="6" style="text-align: center;">
                                NO DATA FOUND
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>